import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button, Card, Col, Container, Row } from "reactstrap"
import moment from "moment"
import { fetchFinanceVoucherSingle } from "../../../services/finance/finance"
import Logo from "../../../assets/images/logo.svg"
import {
  handleDocumentDownload,
  openAndPrintFile,
} from "../../../utils/handleDownload"
import ContraVoucherView from "./viewComponents/contra"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import DebitProductVoucherView from "./viewComponents/debitPro"
import NumberFormat from "../../../utils/numberFormat"
import DebitAccountVoucherView from "./viewComponents/debitAcc"
import SalesInvVoucherView from "./viewComponents/salesInv"
import SalesAccVoucherView from "./viewComponents/salesAcc"
import SalesProInvVoucherView from "./viewComponents/salesProInv"
import PurchaseOrderVoucherView from "./viewComponents/purchaseorder"
const VoucherEntryView = ({ fromDashboard, viewValue }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Voucher Entry${companyname ? ` | ${companyname}` : "MEP -Hub"
    }`
  const { id } = useParams()
  const navigate = useNavigate()
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))
  const desimalrange = localStorage.getItem("desimalrange")

  const { loggedUser } = useSelector(LoginProperties)

  const imgUrl = process.env.REACT_APP_IMG_APIKEY
  const viewId = fromDashboard ? viewValue?.value?.id : id

  const [invoiceDetails, setInvoiceDetails] = useState()
  const [tabledata, setTabledata] = useState()

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""
  const order = locations?.state?.menuLabelaa || ""
  const name = locations?.state?.name || ""
  const pathURL = locations?.state?.url || ""

  useEffect(() => {
    const fetchInvoiceData = async () => {
      const response = await fetchFinanceVoucherSingle(viewId)
      setInvoiceDetails(response?.data)
      setTabledata(response?.data?.purchase_order?.purchaseorder_lists)
    }
    if (viewId !== undefined) fetchInvoiceData()
  }, [])

  return (
    <React.Fragment>
      <div
        className={`${fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
          }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb ? crumb : name ? "Reports" : order ? "Masters" : "Transaction", link: "/finance" },
                  ...(name ? [{ title: "Accounts Book ", link: "/finance" }] : []),
                  // { title: "Voucher Entry", link: "/finance-voucher" },
                  ...(name ? [{ title: name, link: pathURL }] : order ? [{ title: "Purchase Orders", link: "/procurement-purchaseorder" }] : [{ title: "Voucher Entry", link: "/finance-voucher" }]),
                  {
                    title: invoiceDetails?.voucher_type?.voucher_type
                      ? `${invoiceDetails?.voucher_type?.voucher_type} Voucher View`
                      : "Voucher View",
                    link: `/finance-voucher/view/${viewId}`,
                  },
                ]}
              />
            )}
            <div>
              <Button
                color="secondary"
                className="me-3"
                onClick={() =>
                  openAndPrintFile({
                    url: `invoice/${invoiceDetails?.id}`,
                    extension: "pdf",
                  })
                }
              >
                Print
              </Button>
              <Button
                color="info"
                onClick={() =>
                  handleDocumentDownload({
                    id: invoiceDetails?.id,
                    path: invoiceDetails?.ref_number,
                    url: `invoice/${invoiceDetails?.id}`,
                    downloadName: `${invoiceDetails?.voucher_type?.voucher_type
                      }-${invoiceDetails?.ref_number}-${moment().format(
                        "DD-MM-YYYY"
                      )}`,
                    extension: "pdf",
                  })
                }
              >
                Download
              </Button>
              <Button
                color="primary"
                className="ms-3"
                onClick={() =>
                  navigate(`/finance-voucher/edit/${id}`)
                }
              >
                Edit
              </Button>
            </div>
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className="p-3">
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between me-2">
                      <h4 className="main-heading edittheamtitle">
                        {invoiceDetails?.voucher_type?.voucher_type
                          ? `${invoiceDetails?.voucher_type?.voucher_type} Voucher`
                          : "Voucher View"}
                      </h4>
                      <img
                        className="view-logo"
                        src={
                          loggedUser?.settings?.companylogo
                            ? `${imgUrl}${loggedUser?.settings?.companylogo}`
                            : Logo
                        }
                        alt="logo"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={11}>
                    <Row>
                      {invoiceDetails?.voucher_invoice === "Sales Account" ? (
                        <>
                          {invoiceDetails?.debit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Party Name</div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.debit?.name}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_number && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Number
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.ref_number}
                              </div>
                            </Col>
                          )}
                        </>
                      ) : (
                        <>
                          {invoiceDetails?.voucher_type?.voucher_type && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Type
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails
                                  ? invoiceDetails?.voucher_type?.voucher_type
                                  : "-"}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_number && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Number
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.ref_number}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.credit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Party Name</div>
                              <div className="supplier-td-body">
                                {/* {invoiceDetails
                              ? invoiceDetails?.credit?.name
                              : "-"} */}

                                {invoiceDetails?.voucher_type?.voucher_type ==
                                  "Sales"
                                  ? invoiceDetails?.debit?.name
                                  : invoiceDetails?.credit?.name}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_code && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Supplier Inv Ref</div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.ref_code}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_date && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Supplier Inv Date</div>
                              <div className="supplier-td-body">
                                {
                                  invoiceDetails?.ref_date && moment(invoiceDetails?.ref_date).format(
                                    "DD-MM-YYYY"
                                  )
                                }
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.debit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                {invoiceDetails?.voucher_type?.voucher_type ==
                                  "Sales"
                                  ? "Sale Account"
                                  : "Purchase Ledger"}
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.voucher_type?.voucher_type ==
                                  "Sales"
                                  ? invoiceDetails?.credit?.name
                                  : invoiceDetails?.debit?.name}
                              </div>
                            </Col>
                          )}
                        </>
                      )}
                      {invoiceDetails?.parent_voucher?.id && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">
                            Original INV No.
                          </div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.parent_voucher?.ref_number
                              ? invoiceDetails?.parent_voucher?.ref_number
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.inv_date && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Date</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.inv_date
                              ? moment(invoiceDetails?.inv_date).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.date && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Date</div>
                          <div className="supplier-td-body">
                            {invoiceDetails
                              ? moment(invoiceDetails?.date).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </div>
                        </Col>
                      )}

                      {invoiceDetails?.voucher_id == 12 && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Project Code</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.project?.project_code
                              ? invoiceDetails?.project?.project_code
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.voucher_id == 12 && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Transfer Type</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.store_history[0]?.activity
                              ? invoiceDetails?.store_history[0]?.activity ==
                                "remove"
                                ? "Inward"
                                : "Outward"
                              : "-"}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>

                {invoiceDetails?.voucher_id == 1 ||
                  invoiceDetails?.voucher_id == 3 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 8 ||
                  invoiceDetails?.voucher_id == 21 ||
                  ([13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                  ([15, 4].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Purchase Voucher") ? (
                  <ContraVoucherView invoiceDetails={invoiceDetails} />
                ) : invoiceDetails?.voucher_id == 7 ? (
                  <table className="estimation-table mb-4">
                    {/* <thead>
                      <tr>
                        <th>S No</th>
                        <th>Product Code</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th className="text-end pe-2">Ordered Quantity</th>
                        <th className="text-end pe-5">Recieved Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceDetails?.recipt_note?.materials?.map(
                        (data, index) => {
                          return (
                            <tr key={index}>
                              <td className="ps-1">{index + 1}</td>
                              <td className="ps-1">
                                {data?.product?.product_code}
                              </td>
                              <td className="ps-1">
                                {data?.product?.description}{" "}
                              </td>
                              <td className="ps-1">
                                {data?.product?.unit?.unit_code}{" "}
                              </td>
                              <td className="ps-1 text-end pe-2">
                                {NumberFormat(Number(data.po_quantity))}
                              </td>
                              <td className="ps-1 text-end pe-5">
                                {NumberFormat(Number(data.grn_quantity))}
                              </td>
                            </tr>
                          )
                        }
                      )}
                    </tbody> */}
                  </table>
                ) : [15, 4].includes(invoiceDetails?.voucher_id) &&
                  invoiceDetails?.voucher_invoice !== "Purchase Account" ? (
                  <DebitProductVoucherView
                    invoiceDetails={invoiceDetails}
                    tabledata={tabledata}
                  />
                ) : [15, 4].includes(invoiceDetails?.voucher_id) &&
                  invoiceDetails?.voucher_invoice == "Purchase Account" ? (
                  <>
                    <DebitAccountVoucherView
                      invoiceDetails={invoiceDetails}
                      tabledata={tabledata}
                    />
                  </>
                ) : invoiceDetails?.voucher_id == 16 ? (
                  <PurchaseOrderVoucherView
                    invoiceDetails={invoiceDetails}
                    tabledata={tabledata}
                  />
                ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                  invoiceDetails?.voucher_invoice == "Sales Product Invoice" ? (
                  <SalesProInvVoucherView
                    invoiceDetails={invoiceDetails}
                    tabledata={tabledata}
                  />
                ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                  invoiceDetails?.voucher_invoice == "Sales Invoice" ? (
                  <SalesInvVoucherView
                    invoiceDetails={invoiceDetails}
                    tabledata={tabledata}
                  />
                ) : invoiceDetails?.voucher_id == 13 &&
                  invoiceDetails?.voucher_invoice == "Sales Account" ? (
                  <SalesAccVoucherView
                    invoiceDetails={invoiceDetails}
                    tabledata={tabledata}
                  />
                ) : invoiceDetails?.voucher_id == 12 ? (
                  <table className="estimation-table mb-4">
                    {/* <thead>
                      <tr>
                        <th>Si No</th>
                        <th>Product Code</th>
                        <th className="text-end pe-2">Quantity</th>
                        <th className="text-end pe-2">Rate</th>
                        <th className="text-end pe-5">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceDetails?.storeHistory?.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {data?.product_id?.product_code
                                ? data?.product_id?.product_code
                                : "-"}
                            </td>
                            <td className="text-end pe-2">
                              {data?.quantity
                                ? NumberFormat(data?.quantity)
                                : 0}
                            </td>
                            <td className="text-end pe-2">
                              {data?.rate
                                ? NumberFormat(
                                    data?.rate,
                                    desimalrange,
                                    desimalrange
                                  )
                                : 0}
                            </td>
                            <td className="text-end pe-5">
                              {NumberFormat(
                                Number(data?.quantity || 0) *
                                  Number(data?.rate || 0),
                                desimalrange,
                                desimalrange
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody> */}
                  </table>
                ) : (
                  <></>
                )}
              </div>
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VoucherEntryView
